(() => {
  if (window.vainioMeasurementReady) return;
  window.vainioMeasurementReady = true;
  const params = new URLSearchParams(location.search);
  const preview = params.get('preview_theme_id') || document.querySelector('script[data-mt-preview]')?.dataset.mtPreview;
  const root = window.Shopify?.routes?.root || '/';
  const landingUrl = (handle, variant) => {
    const url = new URL(root + 'pages/mittatilaus', location.origin);
    if (preview) {
      url.pathname = root;
      url.searchParams.set('view', 'mittatilaus');
      url.searchParams.set('preview_theme_id', preview);
    }
    if (handle) url.searchParams.set('tuote', handle);
    if (variant) url.searchParams.set('variant', variant);
    return url;
  };
  const startProduct = () => {
    const section = document.querySelector('[id^=MainProduct]');
    const data = section?.querySelector('[data-mt-product]');
    if (!data) return;
    let mode = params.get('mittatilaus') === '1' || params.get('view')?.startsWith('mittatilaus-');
    const back = document.querySelector('[data-mt-back]');
    if (back) back.href = landingUrl();
    if(mode) {
      const title=section.querySelector('.product__title h1');
      if(title&&title.textContent!==data.dataset.mtTitle)title.textContent=data.dataset.mtTitle;
    }
    const text=JSON.parse(data.querySelector('[data-mt-text]').textContent);
    const configureSource=(form,clear=false)=>{
      const source=form.querySelector('[data-mt-source]');
      if(!source)return;
      const method=source.value;
      section.querySelectorAll('[data-mt-visual-method]').forEach(visual=>visual.hidden=visual.dataset.mtVisualMethod!==(method||'garment'));
      form.querySelectorAll('[data-mt-info-method]').forEach(info=>{info.hidden=info.dataset.mtInfoMethod!==method;info.querySelectorAll('details').forEach(details=>details.open=false);});
      form.querySelector('[data-mt-source-property]').value=method?source.selectedOptions[0].textContent:'';
      form.querySelector('[data-mt-form-help]').textContent=method==='body'?text.bodyHelp:method==='garment'?text.garmentHelp:text.sourceHelp;
      form.querySelectorAll('[data-mt-measure]').forEach(input=>{
        const label=method==='body'?input.dataset.bodyLabel:input.dataset.garmentLabel;
        input.closest('label').querySelector('[data-mt-label]').textContent=label;
        input.name='properties['+label+']';input.setAttribute('aria-label',label);
        if(clear){input.value='';input.setCustomValidity('');input.removeAttribute('aria-invalid');}
      });
    };
    document.addEventListener('change',event=>{
      if(event.target.matches('[data-mt-source]')){
        configureSource(event.target.closest('form'),true);
        document.querySelectorAll('[data-mt-guides]').forEach(guide=>guide.dispatchEvent(new CustomEvent('mt-method',{detail:{garment:data.dataset.kind,method:event.target.value}})));
      }
    });
    const simplify=()=>{
      document.documentElement.classList.add('mt-mode');
      const title=section.querySelector('.product__title h1');
      if(title&&title.textContent!==data.dataset.mtTitle)title.textContent=data.dataset.mtTitle;
      section.querySelectorAll('variant-radios fieldset, variant-selects .product-form__input').forEach(group=>{
        const label=group.querySelector('legend,label');
        if(label&&/^(koko|size)(?:\s|$)/i.test(label.textContent.trim()))group.hidden=true;
      });
      section.querySelectorAll('[data-size-picker]').forEach(picker=>{
        picker.hidden=true;
        section.querySelectorAll('label').forEach(label=>{if(label.htmlFor===picker.id)label.hidden=true;});
      });
      section.querySelectorAll('[aria-label="Kustomoinnin vaiheet"],.mt-entry,.product__description,.share-button').forEach(el=>el.hidden=true);
    };
    const measurementUrl=()=>{
      const url=new URL(root+'products/'+data.dataset.handle,location.origin);
      url.searchParams.set('view',data.dataset.mtView);
      url.searchParams.set('mittatilaus','1');
      if(currentVariant())url.searchParams.set('variant',currentVariant());
      return url;
    };
    let switching=false;
    const enterMode=async()=>{
      if(mode){section.querySelector('.mt-fields')?.scrollIntoView({block:'center'});return;}
      if(switching)return;
      switching=true;
      const status=document.createElement('p');status.role='status';status.textContent=text.switchLoading;data.append(status);
      const destination=measurementUrl();
      try{
        const response=await fetch(destination,{credentials:'same-origin'});
        if(!response.ok)throw new Error('View unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const heading=doc.querySelector('[data-mt-back]')?.closest('.shopify-section');
        const guides=doc.querySelector('[data-mt-guides]')?.closest('.shopify-section');
        if(!heading||!guides)throw new Error('Incomplete view');
        const wrapper=section.closest('.shopify-section');
        const main=wrapper.parentElement;
        const importedHeading=document.importNode(heading,true);
        const importedGuides=document.importNode(guides,true);
        [...main.children].forEach(child=>{if(child!==wrapper)child.remove();});
        wrapper.before(importedHeading);wrapper.after(importedGuides);
        importedHeading.querySelector('[data-mt-back]').href=landingUrl();
        history.replaceState({},'',destination);
        mode=true;
        startGuides();
        mount();
        importedHeading.scrollIntoView({block:'start'});
        status.remove();
      }catch{
        status.textContent=text.switchError;
      }finally{switching=false;}
    };
    const formForSection = () => section.querySelector('form[action*="/cart/add"]:not([id*=installment])');
    const currentVariant = () => formForSection()?.querySelector('[name=id]')?.value;
    const bindLink = link => {
      link.href = measurementUrl();
      if (link.dataset.mtBound) return;
      link.dataset.mtBound = 'true';
      link.addEventListener('click',event=>{
        if(event.button||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
        event.preventDefault();enterMode();
      });
    };
    const mount = () => {
      const form = formForSection();
      if (!form) return;
      const original = section.querySelector('.mt-entry');
      if (!original) return;
      bindLink(original);
      if (original.parentElement===data) {
        const guide=section.querySelector('.vainio-size-guide');
        const picker=section.querySelector('variant-radios,variant-selects,[data-size-picker]');
        if(picker)picker.after(original);else if(guide)guide.append(original);else form.before(original);
      }
      section.querySelectorAll('.vainio-size-info').forEach(info=>{
        if(!info.querySelector('.mt-entry')){const link=original.cloneNode(true);delete link.dataset.mtBound;bindLink(link);info.append(link);}
      });
      section.querySelectorAll('.product__description a').forEach(link=>{
        if(/kokotauluk|size chart/i.test(link.textContent)&&!link.nextElementSibling?.classList.contains('mt-entry')) {
          const adjacent=original.cloneNode(true);delete adjacent.dataset.mtBound;bindLink(adjacent);link.after(adjacent);
        }
      });
      if (!mode) return;
      simplify();
      section.querySelectorAll('.product__media-item, .thumbnail-list__item').forEach(item=>{
        if([...item.querySelectorAll('img')].some(img=>/kokotauluk|size.?chart/i.test(img.alt+' '+img.src)))item.hidden=true;
      });
      section.querySelectorAll('.vainio-size-guide,.vainio-size-info').forEach(chart=>chart.hidden=true);
      const media=section.querySelector('.product__media-wrapper');
      if(media&&!media.querySelector('.mt-product-visual')){
        media.append(data.querySelector('[data-mt-visual-template]').content.cloneNode(true));
        const method=form.querySelector('[data-mt-source]')?.value||'garment';
        media.querySelectorAll('[data-mt-visual-method]').forEach(visual=>visual.hidden=visual.dataset.mtVisualMethod!==method);
      }
      if (!form.querySelector('.mt-fields')) {
        const fields=data.querySelector('[data-mt-fields]').content.cloneNode(true);
        const anchor=form.querySelector('.product-form__buttons')||form.querySelector('[type=submit]');
        if(anchor)anchor.before(fields);else form.append(fields);
        configureSource(form);
        const help=form.querySelector('[data-mt-help]');
        help.href='#mittausohjeet';
      }
      form.querySelectorAll('.shopify-payment-button').forEach(el=>{el.hidden=true;});
    };
    const check = form => {
      const source=form.querySelector('[data-mt-source]');
      if(!source?.value){source?.focus();source?.reportValidity();return false;}
      const measures=[...form.querySelectorAll('[data-mt-measure]')];
      const error=form.querySelector('.mt-error');
      if(!measures.length||!error)return false;
      let first;
      measures.forEach(input=>{
        const value=input.value.trim();
        const ok=/^\d+(?:[.,]\d{1,2})?$/.test(value)&&Number(value.replace(',','.'))>0;
        input.setCustomValidity(ok?'':error.textContent);
        input.setAttribute('aria-invalid',String(!ok));
        if(!ok&&!first)first=input;
      });
      error.hidden=!first;
      if(first){first.focus();first.reportValidity();return false;}
      measures.forEach(input=>{input.value=input.value.trim().replace(',','.');});
      return true;
    };
    {
      const guard=event=>{
        if(!mode)return;
        const form=event.target.closest('form');
        if(!form||!section.contains(form)||!form.matches('[action*="/cart/add"]:not([id*=installment])'))return;
        if(event.type==='click'&&!event.target.closest('[type=submit]'))return;
        mount();
        if(!check(form)){event.preventDefault();event.stopImmediatePropagation();}
      };
      document.addEventListener('click',guard,true);
      document.addEventListener('submit',guard,true);
      document.addEventListener('input',event=>{
        if(event.target.matches('[data-mt-measure]')){event.target.setCustomValidity('');event.target.removeAttribute('aria-invalid');}
      });
    }
    let pending=false;
    const observer=new MutationObserver(()=>{
      if(pending)return;pending=true;
      requestAnimationFrame(()=>{pending=false;mount();});
    });
    observer.observe(section,{childList:true,subtree:true});
    mount();
  };
  const startLanding = () => {
    const landing = document.querySelector('[data-mt-landing]');
    if (!landing) return;
    const allCards = [...landing.querySelectorAll('[data-mt-card]')];
    const groups=new Map();
    allCards.forEach(card=>{
      const key=card.dataset.route+':'+card.dataset.group;
      const existing=groups.get(key);
      if(!existing||existing.dataset.female==='true')groups.set(key,card);
    });
    const cards=[...groups.values()];
    allCards.filter(card=>!cards.includes(card)).forEach(card=>card.hidden=true);
    const grid = landing.querySelector('.mt-grid');
    const catalog = landing.querySelector('[data-mt-catalog]');
    const more = landing.querySelector('[data-mt-more]');
    cards.sort((a,b) => Number(a.dataset.rank)-Number(b.dataset.rank));
    cards.forEach(card => grid.append(card));
    let route='';
    let filter = 'all';
    let limit = 12;
    const refreshCards = () => {
      const matching = cards.filter(card=>card.dataset.route===route&&(filter==='all'||card.dataset.kind===filter));
      cards.forEach(card=>{card.hidden=!matching.slice(0,limit).includes(card);});
      more.hidden=matching.length<=limit;
    };
    more.addEventListener('click',()=>{limit+=12;refreshCards();});
    refreshCards();
    landing.querySelectorAll('[data-mt-route]').forEach(button=>button.addEventListener('click',()=>{
      route=button.dataset.mtRoute;limit=12;filter='all';catalog.hidden=false;
      landing.querySelectorAll('[data-mt-route]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      landing.querySelectorAll('[data-mt-route-copy]').forEach(copy=>copy.hidden=copy.dataset.mtRouteCopy!==route);
      landing.querySelectorAll('[data-mt-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.mtFilter==='all')));
      refreshCards();
    }));
    const choose = (card, variant) => {
      if (!card) return;
      const url = new URL(root + 'products/' + card.dataset.handle, location.origin);
      url.searchParams.set('view', card.dataset.view);
      url.searchParams.set('mittatilaus','1');
      if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant',variant);
      if (preview) url.searchParams.set('preview_theme_id',preview);
      location.assign(url);
    };
    cards.forEach(card => card.querySelector('a').addEventListener('click', event => {
      if (event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); choose(card);
    }));
    landing.querySelectorAll('[data-mt-filter]').forEach(button => button.addEventListener('click', () => {
      landing.querySelectorAll('[data-mt-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      filter=button.dataset.mtFilter;limit=12;refreshCards();
    }));
    const selected = params.get('tuote');
    const incoming=allCards.find(card=>card.dataset.handle===selected);
    const card=incoming?groups.get(incoming.dataset.route+':'+incoming.dataset.group):null;
    if (card) choose(card,card.dataset.handle===selected?params.get('variant'):null,false);

  };
  const startGuides=()=>{
    document.querySelectorAll('[data-mt-guides]').forEach(guide=>{
      if(guide.dataset.mtInitialized)return;guide.dataset.mtInitialized='true';
      let garment='';let method='';
      const refresh=()=>{
        guide.querySelector('[data-mt-method-step]').hidden=!garment;
        guide.querySelector('[data-mt-guide-result]').hidden=!garment||!method;
        guide.querySelectorAll('[data-mt-garment]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.mtGarment===garment)));
        guide.querySelectorAll('[data-mt-method]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.mtMethod===method)));
        guide.querySelectorAll('[data-mt-guide-copy]').forEach(copy=>copy.hidden=copy.dataset.mtGuideCopy!==method);
        guide.querySelectorAll('[data-mt-video-garment]').forEach(card=>{
          card.hidden=card.dataset.mtVideoGarment!==garment||card.dataset.mtVideoMethod!==method;
          if(card.hidden)card.querySelectorAll('video').forEach(video=>video.pause());
        });
      };
      guide.querySelectorAll('[data-mt-garment]').forEach(button=>button.addEventListener('click',()=>{garment=button.dataset.mtGarment;method='';refresh();}));
      guide.querySelectorAll('[data-mt-method]').forEach(button=>button.addEventListener('click',()=>{
        method=button.dataset.mtMethod;refresh();
        const data=document.querySelector('[data-mt-product]');
        const source=document.querySelector('form [data-mt-source]');
        if(source&&data?.dataset.kind===garment&&source.value!==method){source.value=method;source.dispatchEvent(new Event('change',{bubbles:true}));}
      }));
      guide.addEventListener('mt-method',event=>{garment=event.detail.garment;method=event.detail.method;refresh();});
      refresh();
    });
  };
  const init = () => {startGuides();startProduct();startLanding();};
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
